import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
  fetchBlendedTimeseries,
  fetchSimulationData,
  fetchTimeSeriesData
} from "../../Api/timeseriesApi";



// Slice for managing time series data
const timeSeriesSlice = createSlice({
  name: 'timeSeries',
  initialState: {
    seriesWindows: {},
    seriesData: {},
    portfolios: {}, // Store portfolio data by pid
    tickers: {}, // Store ticker data by symbol
    blendedSeries: [],
    simulations: {}, // Store simulations data by model name
    loading: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    loadingSlice: false,
    sliceError: false,
    error: null,
  },
  reducers: {
    addBlendedTimeseries: (state, action) => {
      state.blendedSeries.push(action.payload);
    },
    clearBlendedTimeseries: (state) => {
      state.blendedSeries = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeSeriesData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loadingSlice=false;
        data.forEach((series)=>{
          const [seriesId, seriesData] = [series.symbol, series.data];
          const [startDate, endDate] = [seriesData[0].timestamp, seriesData[seriesData.length-1].timestamp];
          state.seriesData[seriesId] = seriesData;
          state.seriesWindows[seriesId] = {startDate, endDate};
        });
      })
        .addCase(fetchTimeSeriesData.pending, (state)=>{
          state.loadingSlice = true;
        })
        .addCase(fetchTimeSeriesData.rejected, (state, action)=>{
            state.loadingSlice = false;
            state.error = action.payload;
            state.sliceError = true;
        })
        .addCase(fetchBlendedTimeseries.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(fetchBlendedTimeseries.fulfilled, (state, action) => {
        state.blended = action.payload;
        state.loading = 'succeeded';
      })
      .addCase(fetchBlendedTimeseries.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.payload;
      })
        .addCase(fetchSimulationData.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(fetchSimulationData.fulfilled, (state, action) => {
        const { modelName, data } = action.payload;
        state.simulations[modelName] = data;
        state.loading = 'succeeded';
      })
      .addCase(fetchSimulationData.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.payload;
      })
  },
});


export const selectTimeSeriesData = createSelector(
  [(state, symbol) => state.timeSeries.seriesData[symbol]],
  (series) => series
);

export const selectManyTimeSeriesData = createSelector(
  [(state, symbols) => symbols.map(symbol => ({symbol, data: state.timeSeries.seriesData[symbol]}))],
  (seriesList) => seriesList.filter(series => series.data !== undefined)
);


export const { addBlendedTimeseries, clearBlendedTimeseries } = timeSeriesSlice.actions;
export default timeSeriesSlice.reducer;
